"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftProposalDto = instanceOfShiftProposalDto;
exports.ShiftProposalDtoFromJSON = ShiftProposalDtoFromJSON;
exports.ShiftProposalDtoFromJSONTyped = ShiftProposalDtoFromJSONTyped;
exports.ShiftProposalDtoToJSON = ShiftProposalDtoToJSON;
exports.ShiftProposalDtoToJSONTyped = ShiftProposalDtoToJSONTyped;
const ShiftProposalStatus_1 = require("./ShiftProposalStatus");
/**
 * Check if a given object implements the ShiftProposalDto interface.
 */
function instanceOfShiftProposalDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('comment' in value) || value['comment'] === undefined)
        return false;
    if (!('commentFromFacility' in value) || value['commentFromFacility'] === undefined)
        return false;
    if (!('commentFromNurse' in value) || value['commentFromNurse'] === undefined)
        return false;
    return true;
}
function ShiftProposalDtoFromJSON(json) {
    return ShiftProposalDtoFromJSONTyped(json, false);
}
function ShiftProposalDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileId': json['nurseProfileId'],
        'status': (0, ShiftProposalStatus_1.ShiftProposalStatusFromJSON)(json['status']),
        'comment': json['comment'],
        'commentFromFacility': json['commentFromFacility'],
        'commentFromNurse': json['commentFromNurse'],
        'proposedStartTime': json['proposedStartTime'] == null ? undefined : json['proposedStartTime'],
        'proposedEndTime': json['proposedEndTime'] == null ? undefined : json['proposedEndTime'],
        'proposedPayRate': json['proposedPayRate'] == null ? undefined : json['proposedPayRate'],
        'proposedTotalRate': json['proposedTotalRate'] == null ? undefined : json['proposedTotalRate'],
        'proposedDate': json['proposedDate'] == null ? undefined : json['proposedDate'],
    };
}
function ShiftProposalDtoToJSON(json) {
    return ShiftProposalDtoToJSONTyped(json, false);
}
function ShiftProposalDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileId': value['nurseProfileId'],
        'status': (0, ShiftProposalStatus_1.ShiftProposalStatusToJSON)(value['status']),
        'comment': value['comment'],
        'commentFromFacility': value['commentFromFacility'],
        'commentFromNurse': value['commentFromNurse'],
        'proposedStartTime': value['proposedStartTime'],
        'proposedEndTime': value['proposedEndTime'],
        'proposedPayRate': value['proposedPayRate'],
        'proposedTotalRate': value['proposedTotalRate'],
        'proposedDate': value['proposedDate'],
    };
}
//# sourceMappingURL=ShiftProposalDto.js.map